import { supabase } from './supabase';

export const PAGE_SLUGS = [
  { slug: 'home', label: 'Home' },
  { slug: 'about', label: 'About' },
  { slug: 'events', label: 'Events' },
  { slug: 'news', label: 'News' },
  { slug: 'contact', label: 'Contact' },
];

export async function fetchAllBackgrounds() {
  const { data, error } = await supabase.from('page_backgrounds').select('*');
  if (error) throw error;
  return data;
}

export async function fetchBackgroundBySlug(pageSlug) {
  const { data, error } = await supabase
    .from('page_backgrounds')
    .select('*')
    .eq('page_slug', pageSlug)
    .maybeSingle();
  if (error) throw error;
  return data;
}

export async function upsertBackground(pageSlug, imageUrl) {
  const { data, error } = await supabase
    .from('page_backgrounds')
    .upsert({ page_slug: pageSlug, image_url: imageUrl }, { onConflict: 'page_slug' })
    .select()
    .single();
  if (error) throw error;
  return data;
}

export async function deleteBackground(pageSlug) {
  const { data: existing } = await supabase
    .from('page_backgrounds')
    .select('image_url')
    .eq('page_slug', pageSlug)
    .maybeSingle();

  const { error } = await supabase
    .from('page_backgrounds')
    .delete()
    .eq('page_slug', pageSlug);

  if (error) throw error;
  return existing?.image_url ?? null;
}
